export default (props) => (
    /**
     * Icone da ferrametna Side By Side
     */
    <svg width="20" height="20" viewBox="0 0 24 20" fill="none" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_185496_14460" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#BEC7DC" />
        </mask>
        <g mask="url(#mask0_185496_14460)">
            <path d="M10 23V21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H10V1H12V23H10ZM5 18H10V12L5 18ZM14 21V12L19 18V5H14V3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H14Z" fill="#BEC7DC" />
        </g>
    </svg>
);
